module.exports = __webpack_public_path__ + "img/2L.acfc2f3f.png";